var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AnimateWhenVisible',{attrs:{"name":"fadeUp"}},[_c('div',{staticClass:"caption"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"text-wrapper"},[_vm._v(_vm._s(_vm.description))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }